export default function () {
  return {
    item: null,
    items: null
  };
}